<template>
  <div>
    <v-dialog v-model="error" width="500">
      <v-card>
        <v-card-title class="headline red accent-3" primary-title>
          Warning Message
        </v-card-title>

        <v-card-text>
          {{ errorMsg }}
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red accent-3" flat @click="setErrorZero"> close </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-toolbar flat color="white">
      <v-toolbar-title>Assistant Requests</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="search"
        label="Search"
        single-line
        hide-details
        align="center"
      ></v-text-field>
      <v-spacer></v-spacer>
      <v-dialog v-model="dialog" max-width="500px">
        <v-card>
          <v-card-title>
            <span class="headline">View Assistant Request</span>
          </v-card-title>

          <v-card-text>
            <v-container grid-list-md>
              <v-layout row>
                <v-flex xs12 sm12 md12>
                  <div class="subheading">
                    <v-chip
                      v-for="(service, index) in getServiceArray(
                        editedItem.services
                      )"
                      :key="index"
                    >
                      <v-avatar class="teal">{{ getFirst(service) }}</v-avatar>
                      {{ service }}
                    </v-chip>
                  </div>
                </v-flex>
              </v-layout>
              <v-layout row>
                <v-flex xs12 sm12 md12>
                  <div class="subheading">
                    <b> Client Name:</b> {{ editedItem.client.name }}
                  </div>
                </v-flex>
              </v-layout>
              <v-layout row>
                <v-flex xs12 sm12 md12>
                  <div class="subheading">
                    <b> Email:</b> {{ editedItem.client.email }}
                  </div>
                </v-flex>
              </v-layout>
              <v-layout row>
                <v-flex xs12>
                  <div class="subheading">
                    <b> Contact Number:</b>
                    {{ editedItem.client.contact_number }}
                  </div>
                </v-flex>
              </v-layout>
              <v-layout row>
                <v-flex xs12>
                  <div class="subheading">
                    <b> Address:</b> {{ editedItem.client.address }}
                  </div>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click="close">Cancel</v-btn>
            <v-btn color="blue darken-1" flat @click="save">Accept</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-toolbar>
    <v-data-table
      :headers="headers"
      :items="indexData.needAssistants"
      :search="search"
      class="elevation-1"
    >
      <template v-slot:items="props">
        <td class="text-xs-center">{{ props.item.id }}</td>
        <td class="text-xs-center">
          <v-chip
            v-for="(service, index) in getServiceArray(props.item.services)"
            :key="index"
          >
            <v-avatar class="teal">{{ getFirst(service) }}</v-avatar>
            {{ service }}
          </v-chip>
        </td>
        <td class="text-xs-center">{{ props.item.client.name }}</td>
        <td class="text-xs-center">
          <v-chip>
            {{ props.item.is_response==1 ? "Processed" : "Pending" }}
          </v-chip>
        </td>
        <td class="justify-center layout px-0">
          <v-icon small class="mr-2" @click="editItem(props.item)">
            visibility
          </v-icon>
          <v-icon small @click="deleteItem(props.item)"> delete </v-icon>
        </td>
      </template>
      <template v-slot:no-data>
        <v-btn color="primary" @click="initialize">Reset</v-btn>
      </template>
    </v-data-table>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  data: () => ({
    dialog: false,
    search: "",
    apiUrl: "need-assistant",
    valid: true,
    headers: [
      { text: "ID", align: "center", value: "id" },
      { text: "Services", align: "center", value: "services" },
      { text: "Requested By", align: "center", value: "client_id" },
      { text: "Response Status", align: "center", value: "is_response" },

      { text: "Actions", align: "center", value: "actions" },
    ],
    editedIndex: -1,
    editedItem: {
      services: "",
      is_response: "",
      client: {
        name: "",
        email: "",
        phone: "",
        address: "",
      },
    },
    defaultItem: {
      services: "",
      is_response: "",
      client: {
        name: "",
        email: "",
        phone: "",
        address: "",
      },
    },
  }),

  computed: {
    ...mapGetters([
      "isLoggedIn",
      "indexData",
      "error",
      "statusCode",
      "errorMsg",
      "userImage",
      "docImage",
    ]),
    formTitle() {
      return this.editedIndex === -1 ? "New Client" : "View Assistant Request";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  created() {
    this.initialize();
  },

  methods: {
    initialize() {
      this.$store.dispatch("setIndexData", [this.apiUrl]);
    },
    getFirst(value) {
      return value.charAt(0);
    },
    mobileValidator(event) {
      // if (event.matches("^(?:\\+88|88)?(01[3-9]\\d{8})$")) {
      //   System.out.println("Yes valid");
      // }

      if (event.match(/^(01[3-9]\d{8})$/)) {
        return true;
      } else {
        return "Invalid mobile number";
      }
    },

    setErrorZero() {
      this.$store.dispatch("setErrorZero");
    },

    editItem(item) {
      this.editedIndex = this.indexData.needAssistants.indexOf(item);
      this.editedItem = Object.assign({}, item);
      // console.log(this.editedItem);
      this.dialog = true;
    },

    deleteItem(item) {
      const index = this.indexData.needAssistants.indexOf(item);
      confirm("Are you sure you want to delete this item?") &&
        this.indexData.needAssistants.splice(index, 1);
      this.$store.dispatch("delete", [this.apiUrl, item.id]);
    },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    getServiceArray(value) {
      return value.split(",");
    },

    isDigit(e) {
      let char = String.fromCharCode(e.keyCode); // Get the character
      if (/^[0-9 +]+$/.test(char)) return false;
      // Match with regex
      else {
        this.digitValidate = true;
        e.preventDefault();
      } // If not match, don't add to input text
    },

    save() {
      if (this.editedIndex > -1) {
        this.$store.dispatch("storeOrUpdate", [
          "process-request",
          this.editedItem,
        ]);
        this.initialize();
      }
      this.close();
    },
  },
};
</script>